import { ApprovalStatus } from "../enums/ApprovalStatus";

export const approvalStatusMap = {
    [ApprovalStatus.Negative]: "accessibility.notice.labels.approvals.negative",
    [ApprovalStatus.Neutral]: "accessibility.notice.labels.approvals.neutral",
    [ApprovalStatus.Positive]: "accessibility.notice.labels.approvals.positive"
} as const;
